import React,{useImperativeHandle,forwardRef} from 'react'
import { 
  Modal,
  Input,
  Form,
  Row,
  Col,
} from 'antd';

const MyModel2 = (props,ref) => {
  const [form] = Form.useForm();
  const [visible, setVisible] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [detailObj, setDetailObj] = React.useState({});
  
  const topCol = {
    span:8,
  }
  const endCol = {
    span:8,
    offset:6
  }

   // 注意useImperativeHandle方法的的第一个参数是目标元素的ref引用
  useImperativeHandle(ref, () => ({
    // showModal 就是暴露给父组件的方法
    showModal: (obj) => {
        setVisible(true)
        setDetailObj(obj)
      }
  }));

 
  return (
    <>
      <Modal maskClosable={false}
        forceRender
        title='查看'
        width='1000px'
        visible={visible}
        footer={false}
        confirmLoading={loading}
        onCancel={() => {setVisible(false);}} >
        <Form form={form}>
        <Row className="margin-15">
            <Col {...topCol}>
              <div className="flex">
                <span className="left-span">类型:</span>
                <Input placeholder={detailObj.ticketTypeName} disabled={true} />
              </div>
            </Col>
           
        </Row>
        <Row className="margin-15">
            <Col {...topCol}>
              <div className="flex">
                <span className="left-span">企业名称:</span>
                <Input placeholder={detailObj.companyName} disabled={true} />
              </div>
            </Col>
            <Col {...endCol}>
              <div className="flex">
                <span className="left-span">纳税人类型:</span>
                <Input placeholder={detailObj.taxpayerTypeName} disabled={true} />
              </div>
            </Col>
        </Row>

        <Row className="margin-15">
            <Col {...topCol}>
              <div className="flex">
                <span className="left-span">统一社会信用代码:</span>
                <Input placeholder={detailObj.taxpayerNumber} disabled={true} />
              </div>
            </Col>
            <Col {...endCol}>
              <div className="flex">
                <span className="left-span">注册电话:</span>
                <Input placeholder={detailObj.registeredPhone} disabled={true} />
              </div>
            </Col>
        </Row>
        <Row className="margin-15">
            <Col {...topCol}>
              <div className="flex">
                <span className="left-span">注册地址:</span>
                <Input placeholder={detailObj.address} disabled={true} />
              </div>
            </Col>
            <Col {...endCol}>
              <div className="flex">
                <span className="left-span">对公账户:</span>
                <Input placeholder={detailObj.bankNumber} disabled={true} />
              </div>
            </Col>
        </Row>
        <Row className="margin-15">
            <Col {...topCol}>
              <div className="flex">
                <span className="left-span">开户银行:</span>
                <Input placeholder={detailObj.bankName} disabled={true} />
              </div>
            </Col>
            <Col {...endCol}>
              <div className="flex">
                <span className="left-span">收件人:</span>
                <Input placeholder={detailObj.receiptName} disabled={true} />
              </div>
            </Col>
        </Row>
        <Row className="margin-15">
            <Col {...topCol}>
              <div className="flex">
                <span className="left-span">收件电话:</span>
                <Input placeholder={detailObj.receiptPhone} disabled={true} />
              </div>
            </Col>
            <Col {...endCol}>
              <div className="flex">
                <span className="left-span">收件地址:</span>
                <Input placeholder={detailObj.receiptAddress} disabled={true} />
              </div>
            </Col>
        </Row>
        {
          detailObj.ticketTypeName == '企业申请'
          ? <Row className="margin-15">
          <Col {...topCol}>
            <div className="flex">
              <span className="left-span">申请开票时间:</span>
              <Input placeholder={detailObj.createTime} disabled={true} />
              </div>
            </Col>
            <Col {...endCol}>
              <div className="flex">
                <span className="left-span">申请开票金额:</span>
                <Input placeholder={detailObj.ticketAmount} disabled={true} />
              </div>
            </Col>
        </Row>
      :<div>
           <Row className="margin-15">
            <Col {...topCol}>
              <div className="flex">
                <span className="left-span">确认退费时间:</span>
                <Input placeholder={detailObj.backCostTime} disabled={true} />
              </div>
            </Col>
        </Row>
        <Row className="margin-15">
            <Col {...topCol}>
              <div className="flex">
                <span className="left-span">退费月份:</span>
                <Input placeholder={detailObj.backCostMonth} disabled={true} />
              </div>
            </Col>
            <Col {...endCol}>
              <div className="flex">
                <span className="left-span">开票金额:</span>
                <Input placeholder={detailObj.ticketAmount} disabled={true} />
              </div>
            </Col>
        </Row>
      </div>
    }
{
  
    detailObj.status == 'KPCG'
    ?<div>
       <Row className="margin-15">
            <Col {...topCol}>
              <div className="flex">
                <span className="left-span">确认开票时间:</span>
                <Input placeholder={detailObj.ticketTime} disabled={true} />
              </div>
            </Col>
        </Row>
        <Row className="margin-15">
            <Col {...topCol}>
              <div className="flex">
                <span className="left-span">操作人:</span>
                <Input placeholder={detailObj.ticketUser} disabled={true} />
              </div>
            </Col>
        </Row>
        <Row className="margin-15">
            <Col {...topCol}>
              <div className="flex">
                <span className="left-span">开票备注:</span>
                <Input placeholder={detailObj.ticketNote} disabled={true} />
              </div>
            </Col>
          
        </Row>
    </div>
    :null
}
       
        </Form>
      </Modal>
    </>
  );
};
export default forwardRef(MyModel2)



